import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
function describeCadence(c, t) {
    if (c === undefined)
        return t('aggregation.confirmation.cadence_unspecified');
    switch (c.kind) {
        case 'patient-initiated':
            return t('aggregation.per_holder.cadence.patient_initiated');
        case 'scheduled':
            return t('aggregation.confirmation.cadence_scheduled_template', { days: c.intervalDays });
        case 'substrate-event-triggered':
            return t('aggregation.per_holder.cadence.substrate_event_triggered');
    }
}
function describeRetention(r, t) {
    if (r === undefined)
        return t('aggregation.confirmation.retention_unspecified');
    switch (r.kind) {
        case 'forever':
            return t('aggregation.per_holder.retention.forever');
        case 'bounded-years':
            return t('aggregation.confirmation.retention_bounded_years_template', { years: r.years });
        case 'until-revoke':
            return t('aggregation.per_holder.retention.until_revoke');
    }
}
export function AggregationElectionConfirmationStep(props) {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "confirmation-heading", children: [_jsx("h3", { id: "confirmation-heading", children: t('aggregation.confirmation.heading') }), _jsx("p", { children: t('aggregation.confirmation.body') }), _jsx("ul", { "aria-label": t('aggregation.confirmation.holders_aria_label'), children: props.configs.map((c) => (_jsxs("li", { children: [_jsx("strong", { children: c.holderId }), _jsxs("dl", { children: [_jsx("dt", { children: t('aggregation.confirmation.field.data_categories') }), _jsx("dd", { children: c.dataCategories.join(', ') }), _jsx("dt", { children: t('aggregation.confirmation.field.cadence') }), _jsx("dd", { children: describeCadence(c.cadence, t) }), _jsx("dt", { children: t('aggregation.confirmation.field.retention') }), _jsx("dd", { children: describeRetention(c.retention, t) })] })] }, c.holderId))) }), _jsxs("div", { role: "group", "aria-label": t('aggregation.confirmation.actions_aria_label'), children: [_jsx("button", { type: "button", onClick: props.onConfirm, children: t('aggregation.confirmation.confirm') }), _jsx("button", { type: "button", onClick: props.onCancel, children: t('aggregation.confirmation.cancel') })] })] }));
}
//# sourceMappingURL=election-confirmation-step.js.map